import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'router-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🔀 Mosaic Router</h1>
            <p class='section-text' tabindex='0'>
                The <b>Mosaic Router</b> is a basic, client-side routing solution
                that allows you to use components as web pages. All you have to do
                is add a separate route for each of your components, and when the
                url changes you will see the view change as well.
            </p>
            <h1 class='section-title' tabindex='0'>
                addRoute(path: <span style='color:mediumseagreen'>string or string[]</span>,
                component?: <span style='color:mediumseagreen'>Mosaic</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                The <b>addRoute</b> function is used to define the routes of your web 
                app. The first parameter is either a string or an array of strings that
                represents the url endpoints for which you want to show your component.
                And the second parameter is the component that you want to show at those
                endpoints.
            </p>
            <code-segment type='JS'>
                const home = new Mosaic({ ... });
                <br>
                const about = new Mosaic({ ... });
                <br><br>
                router.addRoute(["/", "/home"], home);
                <br>
                router.addRoute("/about", about);
            </code-segment>
            <br>

            <code-segment type='JS'>
                const msg = portfolio.get("message");
                <br>
                console.log(msg);
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>
                paint()
            </h1>
            <p class='section-text' tabindex='0'>
                The <b>paint</b> function is used to inject the router into the DOM.
                It works the same way as a component's paint function, by adding the
                component as a child of the root element.
            </p>
            <code-segment type='JS'>
                router.paint();
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>
                send(to: <span style='color:mediumseagreen'>string</span>,
                data?: <span style='color:mediumseagreen'>Object</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                <b>Send</b> is used to move to different pages thruoughout your app.
                The first parameter is the endpoint that you would like to send your
                app to (such as "/about" or "/contact"), and the second parameter is
                an optional object which represents data that you can send over to 
                the new route.
            </p>
            <code-segment type='JS'>
                router.send("/about", { extraData: "This can be accessed from the next page!" });
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>
                setNotFound(component: <span style='color:mediumseagreen'>Mosaic</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                <b>setNotFound</b> is used to define the component that should be rendered
                if a url endpoint has not been registered on the router. The only parameter
                is a Mosaic instance to show when the route is not defined.
            </p>
            <code-segment type='JS'>
                const notFound = new Mosaic({ ... });
                <br>
                router.setNotFound(notFound);
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>Demo</h1>
            <p class='section-text' tabindex='0'>
                The Mosaic Router is actually being used to render this website! You'll
                notice that when you switch pages the website does not reload. That is
                because the router simply changes the components so that the page does
                not have to reload. The demo below from JSFiddle, however, cannot be
                accurately tested because changing the url would not even give you back
                the correct page.
            </p>
            <br>
            <iframe width="100%" height="300" src="//jsfiddle.net/authman2/e8nuydLo/122/embedded/js,html/" allowfullscreen="allowfullscreen" allowpaymentrequest frameborder="0"></iframe>
            
            <p class='section-text' tabindex='0' style='text-align:center;'>
                In the next section we will talk about the "descendants" property
                and how you can use it as another way to inject data into your
                components.
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/portfolio')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Portfolio
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/descendants')}'>
                    Descendants
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});